import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DebitNoteProductForEdit {
  id: number;
  productId: number;
  productName: string;
  quantity: number;
  unitCost: number;
  ivaAmount: number;
  totalAmount: number;
  type: 'PRICE_INCREASE' | 'ADJUSTMENT';
  distributionPercent: number;
  purchaseReferenceCode: string;
}

export interface DebitNoteServiceForEdit {
  detailId: number;
  serviceDescription: string;
  quantity: number;
  unitCost: number;
  totalAmount: number;
}

interface DebitNoteState {
  productToEdit: DebitNoteProductForEdit | null;
  serviceToEdit: DebitNoteServiceForEdit | null;
  showAddProductModal: boolean;
  showAddServiceModal: boolean;
  showPriceAdjustmentModal: boolean;
}

const initialState: DebitNoteState = {
  productToEdit: null,
  serviceToEdit: null,
  showAddProductModal: false,
  showAddServiceModal: false,
  showPriceAdjustmentModal: false
};

const debitNoteSlice = createSlice({
  name: 'debitNote',
  initialState,
  reducers: {
    setProductToEdit(state, action: PayloadAction<DebitNoteProductForEdit>) {
      state.productToEdit = action.payload;
    },
    setServiceToEdit(state, action: PayloadAction<DebitNoteServiceForEdit>) {
      state.serviceToEdit = action.payload;
    },
    clearProductToEdit(state) {
      state.productToEdit = null;
    },
    clearServiceToEdit(state) {
      state.serviceToEdit = null;
    },
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },
    openAddServiceModal(state) {
      state.showAddServiceModal = true;
    },
    closeAddServiceModal(state) {
      state.showAddServiceModal = false;
    },
    openPriceAdjustmentModal(state) {
      state.showPriceAdjustmentModal = true;
    },
    closePriceAdjustmentModal(state) {
      state.showPriceAdjustmentModal = false;
    },    
  },
});

export const {
  setProductToEdit,
  clearProductToEdit,
  openAddProductModal,
  closeAddProductModal,

  // ✅ Acciones para servicio
  setServiceToEdit,
  clearServiceToEdit,
  openAddServiceModal,
  closeAddServiceModal,
  openPriceAdjustmentModal,
  closePriceAdjustmentModal
} = debitNoteSlice.actions;

export default debitNoteSlice.reducer;
